//PDF Renderer
import { Image, Page, Text, StyleSheet, View, Font } from "@react-pdf/renderer";

//Fonts
import montserratRegular from "../../fonts/Montserrat-Regular.ttf";

//Imagenes
import elco from "../../Assets/elco.png";

//Helpers
import {
  existingRenders,
  selectProductRender,
} from "../../Helpers/productSelector";
import { getFechaAlLoTico } from "../../Helpers/date";

Font.register({
  family: "Montserrat-Regular",
  src: montserratRegular,
});

const columnTitles = [
  "Cantidad",
  "Detalle del producto",
  "Precio por unidad",
  "IVA por unidad",
  "Total",
];

const styles = StyleSheet.create({
  body: {
    fontFamily: "Montserrat-Regular",
    padding: 20,
  },
  elcoLogo: {
    maxWidth: "100px",
    marginBottom: "20px",
  },
  title: {
    fontSize: 24,
    textAlign: "center",
  },
  description: {
    fontSize: 12,
    textAlign: "center",
    marginTop: 40,
    marginBottom: 40,
  },
  imagesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  imageItem: {
    width: "150px",
    marginRight: "20px",
  },
  productImage: {
    height: "65px",
    width: "65px",
  },
  divider: {
    height: "2px",
    marginTop: "10px",
    marginBottom: "10px",
    backgroundColor: "#000",
  },
  text: {
    fontSize: 11,
  },
  smallText: {
    fontSize: 9.5,
    marginTop: 10,
  },
  boldText: {
    fontSize: 13,
  },
  topRightText: {
    position: "absolute",
    top: 20,
    right: 20,
    fontSize: "9.5px",
  },
  table: {
    marginTop: 10,
  },
  headerRow: {
    flexDirection: "row",
    textAlign: "center",
  },
  headerCell: {
    flex: 0.5,
    borderWidth: 1,
    borderColor: "black",
    backgroundColor: "#38BFC2",
    padding: 4,
    color: "white",
    fontSize: "9.5px",
  },
  secondColumnHeader: {
    flex: 2.5,
    borderWidth: 1,
    borderColor: "black",
    backgroundColor: "#38BFC2",
    padding: 4,
    color: "white",
    fontSize: "10px",
  },
  secondColumn: {
    flex: 2.5,
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "black",
    padding: 4,
    fontSize: "9.5px",
  },
  secondColumnImg: {
    width: "25%",
  },
  secondColumnTxt: {
    width: "75%",
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    flex: 0.5,
    borderWidth: 1,
    borderColor: "black",
    padding: 4,
    fontSize: "9.5px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  amountContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  quoteDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
  },
});

export const generateQuoteDocument = (data, id, expDate) => {
  // ==========> Component Functions <==========
  //Check the currency
  const generateCurrencyIcon = () => {
    if (data.billing.currency === "CRC") {
      return "₡";
    } else {
      return "$";
    }
  };

  //Check the currency
  const generateCurrencyText = () => {
    if (data.billing.currency === "CRC") {
      return "Moneda: Colones (CRC)";
    } else {
      return "Moneda: Dólares Americanos (USD)";
    }
  };
  //Function to generate quote amounts
  const generateQuoteAmount = () => {
    let pretaxAmount = 0;
    let taxes = 0;

    for (const product of data.products) {
      let beforeTaxes = Number(product.price) * product.quantity;

      pretaxAmount += beforeTaxes;
    }
    //Definir el descuento
    let discount = pretaxAmount * (data.billing.discountPercentage / 100);
    //Quitar el descuento al pretax
    pretaxAmount -= discount;
    //Sacar el IVA del pretax ya con el descuento aplicado
    taxes = pretaxAmount * (data.billing.taxesPercentage / 100);

    return {
      subtotal: Number(pretaxAmount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      discount: Number(discount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      iva: Number(taxes).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      total: Number(pretaxAmount + taxes).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    };
  };
  //Function to generate product image
  const generateProductImage = (product) => {
    if (existingRenders.includes(product)) {
      return (
        <Image style={styles.productImage} src={selectProductRender(product)} />
      );
    } else {
      return null;
    }
  };

  // ==========> Component <==========
  return (
    <Page style={styles.body}>
      <Image style={styles.elcoLogo} src={elco} />
      <Text style={styles.text}>CRC Mechatronics Systems S.A</Text>
      <Text style={styles.text}>
        Dirección: 25m Este de antigua casa Matute Gómez, Barrio Lahmann,
        Catedral San José.
      </Text>
      <Text style={styles.text}>Cédula jurídica: 3-101-693410</Text>
      <Text style={styles.text}>Teléfono: 8348-5325</Text>
      <Text style={styles.text}>Dirección web: www.elcocrc.com</Text>
      <Text style={styles.text}>Correo electrónico: info@elcocrc.com</Text>
      <Text style={styles.text}>Facebook: @ELCOCRC</Text>

      <div style={styles.divider}></div>

      <div style={styles.quoteDetailsContainer}>
        <Text style={styles.text}>{`Cliente: ${data.client.name}`}</Text>
        {data.client.id !== "" && (
          <Text style={styles.text}>{`Identificación: ${data.client.id}`}</Text>
        )}
        {data.client.phone !== "" && (
          <Text style={styles.text}>{`Teléfono: ${data.client.phone}`}</Text>
        )}
        {data.client.email !== "" && (
          <Text
            style={styles.text}
          >{`Correo electrónico: ${data.client.email}`}</Text>
        )}
      </div>

      <View style={styles.table}>
        <View style={styles.headerRow}>
          {columnTitles.map((title, index) => (
            <View
              key={index}
              style={
                index === 1 ? styles.secondColumnHeader : styles.headerCell
              }
            >
              <Text>{title}</Text>
            </View>
          ))}
        </View>
        {data.products.map((product) => (
          <View key={product.id} style={styles.row}>
            <View style={styles.cell}>
              <Text>{product.quantity}</Text>
            </View>
            <View style={styles.secondColumn}>
              {generateProductImage(product.productName) && (
                <div style={styles.secondColumnImg}>
                  {generateProductImage(product.productName)}
                </div>
              )}
              <div
                style={
                  generateProductImage(product.productName) &&
                  styles.secondColumnTxt
                }
              >
                <Text>{product.productName}</Text>
                <Text>{product.specifications}</Text>
                {product.discountPercentage !== 0 && (
                  <Text style={styles.smallText}>
                    {`Se aplicó un descuento de ${product.discountPercentage}% a este producto.`}
                  </Text>
                )}
              </div>
            </View>
            <View style={styles.cell}>
              <Text>{`${generateCurrencyIcon()}${Number(
                product.price
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}</Text>
            </View>
            <View style={styles.cell}>
              <Text>{`${generateCurrencyIcon()}${Number(
                (Number(product.price) * Number(data.billing.taxesPercentage)) /
                  100
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}</Text>
            </View>
            <View style={styles.cell}>
              <Text>{`${generateCurrencyIcon()}${Number(
                (Number(product.price) +
                  (Number(product.price) *
                    Number(data.billing.taxesPercentage)) /
                    100) *
                  product.quantity
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}</Text>
            </View>
          </View>
        ))}
      </View>

      <div style={styles.quoteDetailsContainer}>
        {data.notes !== "" && (
          <Text
            style={styles.text}
          >{`Notas de cotización: ${data.notes}`}</Text>
        )}
        <Text style={styles.text}>
          {data.billing.aditional &&
            `Información de entrega: ${data.billing.aditional}`}
        </Text>
        <Text
          style={styles.text}
        >{`Forma de pago: ${data.billing.paymentMethod}`}</Text>

        <Text style={styles.text}>{generateCurrencyText()}</Text>
      </div>

      <div style={styles.divider}></div>

      <div style={styles.amountContainer}>
        <Text style={styles.text}>Subtotal</Text>
        <Text style={styles.text}>{`${generateCurrencyIcon()}${
          generateQuoteAmount().subtotal
        }`}</Text>
      </div>
      {data.billing.discountPercentage !== 0 && (
        <div style={styles.amountContainer}>
          <Text style={styles.text}>Descuento</Text>
          <Text style={styles.text}>{`(${generateCurrencyIcon()}${
            generateQuoteAmount().discount
          })`}</Text>
        </div>
      )}

      <div style={styles.amountContainer}>
        <Text style={styles.text}>IVA</Text>
        <Text style={styles.text}>{`${generateCurrencyIcon()}${
          generateQuoteAmount().iva
        }`}</Text>
      </div>

      <div style={styles.amountContainer}>
        <Text style={styles.text}>Total Proforma</Text>
        <Text style={styles.boldText}>{`${generateCurrencyIcon()}${
          generateQuoteAmount().total
        }`}</Text>
      </div>

      <View style={styles.topRightText}>
        <Text>{`Factura Proforma ${id}-${new Date().getFullYear()}`}</Text>
        <Text>{`Fecha: ${getFechaAlLoTico(new Date(data.createdAt))}`}</Text>
      <Text>{`Vencimiento: ${getFechaAlLoTico(new Date(expDate))}`}</Text>
      </View>
    </Page>
  );
};
